/* eslint-disable */
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { useEffect, useMemo, useState } from "react";
import { usePermissions } from "hooks/usePermissions";
import { Tooltip } from "components/ui/tooltip";
import { FaAngleDown } from "react-icons/fa6";
import { FaAngleUp } from "react-icons/fa6";
import { isEmpty } from "lodash";

export const SidebarLinks = (props: {
  routes: any[];
  openSide: any;
}): React.ReactNode => {
  let location = useLocation();
  const [isactive, setisactive] = useState("");
  const { routes, openSide } = props;
  const [activeParentObj, setActiveParentObj] = useState<null | any>(null);
  const { hasPermission } = usePermissions();

  const [collapsedRoutes, setCollapsedRoutes] = useState([]);

  // Function to toggle collapse state
  const toggleCollapse = (index: number) => {
    setCollapsedRoutes((prev) =>
      prev.includes(index)
        ? prev.filter((item) => item !== index)
        : [...prev, index]
    );
  };

  const normalizePath = (path: string) => path.replace(/^\/+|\/+$/g, "");

  const activeObject = useMemo(() => {
    const activeObjFind = routes.reduce((active: any[], item: any) => {
      if (item.children) {
        // Normalize pathname and replace 'superuser'
        let cleanedPathname = normalizePath(
          location.pathname.replace(/\/superuser\//, "/")
        );

        // Check if any child path matches the current pathname
        const findChildObj = item.children.filter((childItem: any) => {
          const normalizedChildPath = normalizePath(childItem.path);
          const regex = new RegExp(`^${normalizedChildPath}(\/|$)`);
          const match = regex.test(cleanedPathname);
          return match;
        });

        // If there are matching children, add the parent item to the result array
        if (findChildObj.length > 0) {
          active.push(item);
        }
      }
      return active;
    }, []);

    if (activeObjFind.length > 0) {
      setActiveParentObj(activeObjFind[0]);
    } else {
      setActiveParentObj(null);
    }
    return activeObjFind;
  }, [location]);

  useEffect(() => {
    setisactive(location.pathname);
  }, [location.pathname]);

  const createLinks = (routes: any[]) => {
    return routes.map((route, index) => {
      const isActiveParent = activeParentObj && activeParentObj.name === route.name;
      const isActiveRoute = route.path
        ? new RegExp(`${route.layout}\/${route.path.replace(/:[^/]+/g, '[^/]+')}(\/|$)`).test(location.pathname)
        : false;

      if (route.layout === "/superuser") {
        if (route.children) {
          const visibleChildren = route.children.filter((r: any) => !r.module || hasPermission(r.module, "READ"));
          if (visibleChildren.length === 0) return null;

          return (
            <div key={index} className="flex flex-col">
              <button
                onClick={() => toggleCollapse(index)}
                className={`group mb-1 flex w-full cursor-pointer items-center rounded-xl py-2.5 transition-all duration-200 hover:bg-brand-50/50 dark:hover:bg-white/5 ${
                  isActiveParent ? "bg-brand-50/80 dark:bg-brand-900/20" : ""
                } ${openSide ? "justify-between px-3" : "justify-center px-0"}`}
              >
                {openSide ? (
                  <div className="flex items-center">
                    <span
                      className={`sidebar-icon text-[18px] transition-colors ${
                        isActiveParent
                          ? "text-brand-600 dark:text-brand-400"
                          : "text-gray-600 dark:text-gray-400 group-hover:text-brand-500 dark:group-hover:text-gray-200"
                      }`}
                    >
                      {route.icon ? route.icon : <DashIcon />}
                    </span>
                    <p
                      className={`ml-3 text-sm font-medium transition-colors ${
                        isActiveParent
                          ? "font-semibold text-brand-700 dark:text-white"
                          : "text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-white"
                      }`}
                    >
                      {route.name}
                    </p>
                  </div>
                ) : (
                  <Tooltip
                    content={route.name}
                    
                    contentProps={{ bg: "gray.800", color: "white" }}
                    showArrow
                  >
                    <span
                      className={`sidebar-icon text-[18px] transition-colors ${
                        isActiveParent
                          ? "text-brand-600 dark:text-brand-400"
                          : "text-gray-600 dark:text-gray-400 group-hover:text-brand-500 dark:group-hover:text-gray-200"
                      }`}
                    >
                      {route.icon ? route.icon : <DashIcon />}
                    </span>
                  </Tooltip>
                )}
                {openSide && (
                  <span
                    className={`text-[12px] text-gray-500 transition-transform duration-300 ${
                      collapsedRoutes.includes(index) ? "rotate-180 text-brand-500" : ""
                    }`}
                  >
                    <FaAngleDown />
                  </span>
                )}
              </button>
              <div
                className={`collapse-content overflow-hidden transition-all duration-300 ${
                  collapsedRoutes.includes(index) ? "opacity-100 mt-1 mb-2" : "max-h-0 opacity-0 hidden"
                }`}
              >
                {collapsedRoutes.includes(index) &&
                  visibleChildren.map((r: any, indexChild: any) => {
                    if (!r.path) return null;
                    const isActiveChild = new RegExp(
                      `${r.layout}\/${r.path.replace(/:[^/]+/g, '[^/]+')}(\/|$)`
                    ).test(location.pathname);
                    
                    return (
                      <div key={indexChild} className={`${!r.sidebar && "hidden"}`}>
                        <Link to={r.layout + "/" + r.path}>
                           <div
                            className={`group relative mb-1 flex cursor-pointer items-center rounded-lg py-2 transition-all duration-200 hover:bg-brand-50/50 dark:hover:bg-white/5 ${
                              isActiveChild ? "bg-brand-50/90 dark:bg-brand-900/30" : ""
                            } ${openSide ? "mx-1.5 px-3" : "w-full justify-center px-0"}`}
                          >
                            {openSide ? (
                              <div className="flex w-full items-center">
                                <span
                                  className={`sidebar-child-icon text-[16px] transition-colors ${
                                    isActiveChild
                                      ? "text-brand-600 dark:text-brand-400"
                                      : "text-gray-500 group-hover:text-brand-500 dark:group-hover:text-gray-300"
                                  }`}
                                >
                                  {r.icon ? r.icon : <DashIcon />}
                                </span>
                                <p
                                  className={`ml-2.5 text-xs transition-colors ${
                                    isActiveChild
                                      ? "font-semibold text-brand-700 dark:text-white"
                                      : "font-medium text-gray-600 dark:text-gray-400 group-hover:text-gray-800 dark:group-hover:text-gray-200"
                                  }`}
                                >
                                  {r.name}
                                </p>
                              </div>
                            ) : (
                              <Tooltip content={r.name}  contentProps={{ bg: "gray.800", color: "white" }} showArrow>
                                <span
                                  className={`sidebar-child-icon text-[16px] transition-colors ${
                                    isActiveChild
                                      ? "text-brand-600 dark:text-brand-400"
                                      : "text-gray-500 group-hover:text-brand-500 dark:group-hover:text-gray-300"
                                  }`}
                                >
                                  {r.icon ? r.icon : <DashIcon />}
                                </span>
                              </Tooltip>
                            )}
                            
                            {isActiveChild && (
                              <div className="absolute left-0 top-1/2 h-5 w-1 -translate-y-1/2 rounded-r-lg bg-brand-500 dark:bg-brand-400" />
                            )}
                          </div>
                        </Link>
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        } else {
          if (!route.path) return null;
          if (route.module && !hasPermission(route.module, "READ")) return null;
          
          return (
            <div key={index} className={!route.sidebar ? "hidden" : ""}>
              <Link to={route.layout + "/" + route.path} className="w-full">
                <div
                  className={`group relative mb-1 flex w-full cursor-pointer items-center rounded-xl py-2.5 transition-all duration-200 hover:bg-brand-50/50 dark:hover:bg-white/5 ${
                    isActiveRoute ? "bg-brand-50/90 dark:bg-brand-900/20 shadow-sm" : ""
                  } ${openSide ? "px-3" : "justify-center px-0"}`}
                >
                  {openSide ? (
                    <div className="flex w-full items-center">
                      <span
                        className={`sidebar-icon text-[18px] transition-colors ${
                          isActiveRoute
                            ? "text-brand-600 dark:text-brand-400"
                            : "text-gray-600 dark:text-gray-400 group-hover:text-brand-500 dark:group-hover:text-gray-200"
                        }`}
                      >
                        {route.icon ? route.icon : <DashIcon />}
                      </span>
                      <p
                        className={`ml-3 text-sm transition-colors ${
                          isActiveRoute
                            ? "font-semibold text-brand-700 dark:text-white"
                            : "font-medium text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-white"
                        }`}
                      >
                        {route.name}
                      </p>
                    </div>
                  ) : (
                    <Tooltip content={route.name}  contentProps={{ bg: "gray.800", color: "white" }} showArrow>
                      <span
                        className={`sidebar-icon text-[18px] transition-colors ${
                          isActiveRoute
                            ? "text-brand-600 dark:text-brand-400"
                            : "text-gray-600 dark:text-gray-400 group-hover:text-brand-500 dark:group-hover:text-gray-200"
                        }`}
                      >
                        {route.icon ? route.icon : <DashIcon />}
                      </span>
                    </Tooltip>
                  )}
                  
                  {isActiveRoute && (
                    <div className={`absolute left-0 top-1/2 h-6 w-1.5 -translate-y-1/2 rounded-r-lg bg-brand-500 dark:bg-brand-400 shadow-[0_0_10px_rgba(79,70,229,0.2)]`} />
                  )}
                </div>
              </Link>
            </div>
          );
        }
      }
      return null;
    });
  };

  // BRAND
  return <>{createLinks(routes)}</>;
};

export default SidebarLinks;
